<template>
  <div>
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-xl-6">
            <ul class="footerMemu">
              <li>
                <router-link to="/trenim-nerede" tag="a">
                  {{ $t("train-tracking-title") }}
                </router-link>
              </li>
              <li>
                <router-link to="/acik-biletlerim" tag="a">
                  {{ $t("base-footer-my-open-ticket") }}
                </router-link>
              </li>
              <li>
                <router-link to="/engelsiz-ulasim" tag="a">
                  {{ $t("base-footer-barrier-free-transportation") }}
                </router-link>
              </li>
              <li>
                <a target="_blank" href="https://www.tcddtasimacilik.gov.tr/seferler/bolgesel-trenler/">{{ $t("base-footer-regional-train") }}</a>
              </li>
              <li>
                <router-link to="/yardim" tag="a">
                  {{ $t("base-footer-solution-center") }}
                </router-link>
              </li>
              <li>
                <router-link to="/iletisim" tag="a">
                  {{ $t("base-footer-contact") }}
                </router-link>
              </li>
              <li>
                <router-link to="/yolcu-tasima-kurallari" tag="a">
                  {{ $t("base-footer-passenger-transport-rules") }}
                </router-link>
              </li>
              <li>
                <router-link to="/yardim-talep-formu" tag="a">
                  {{ $t("base-footer-help-request-form") }}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-6 col-xl-3">
            <div class="info">
              <div class="media">
                <img src="/src/images/icon-footer-adress.svg" class="mr-3" alt="icon-footer-adress" loading="lazy" />
                <div class="media-body">
                  <h5 class="mt-0">{{ $t("base-footer-TCDD") }}</h5>
                  <p>{{ $t("base-footer-message") }}</p>
                </div>
              </div>
              <router-link tag="a" to="/yardim" exact class="media">
                <img src="/src/images/icon-miys.svg" class="mr-3" alt="icon-miys" />
                <div class="media-body">
                  <h5 class="mt-0">{{ $t("base-footer-solution-center") }}</h5>
                  <p>{{ $t("base-footer-message-v2") }}</p>
                </div>
              </router-link>
            </div>
          </div>

          <div class="col-md-6 col-xl-3">
            <!-- social start -->
            <section class="social">
              <a href="https://www.facebook.com/tcddtasimacilikgovtr/about/" target="_blank">
                <img src="/src/images/icon-facebook.svg" alt="tcdd-facebook" />
              </a>
              <a href="https://twitter.com/TCDDTasimacilik?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank">
                <img src="/src/images/icon-twitter.svg" alt="tcdd-twitter" />
              </a>
              <a href="https://www.instagram.com/tcddtasimacilik/" target="_blank">
                <img src="/src/images/icon-instagram.svg" alt="tcdd-instagram" />
              </a>
              <a href="https://www.linkedin.com/company/tcdd/" target="_blank">
                <img src="/src/images/icon-linkedin.svg" alt="tcdd-linkedin" />
              </a>
            </section>
            <!-- social end -->
            <div class="fmenu">
              <a href="https://wa.me/905073218233" target="_blank" class="whatsApp">{{ $t("base-footer-whatsapp") }}</a>
              <a href="tel:4448233" target="_blank" class="callCenter">{{ $t("base-footer-call-center") }}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="container">
          <div class="copyright">© {{ new Date().getFullYear() + $t("base-footer-copyright") }}</div>
        </div>
      </div>
    </footer>
    <!-- 7 region -->
    <div class="line-region">
      <div class="region-col first"></div>
      <div class="region-col second"></div>
      <div class="region-col third"></div>
      <div class="region-col fourth"></div>
      <div class="region-col fifth"></div>
      <div class="region-col sixth"></div>
    </div>
    <!-- Rate us -->
    <section class="rateUsArea">
      <rate-us-component />
    </section>
  </div>
</template>

<script>
import RateUsComponent from "../RateUsComponent.vue";
export default {
  name: "BaseFooter",
  components: { RateUsComponent },
};
</script>

<style lang="scss" scoped>
.footer {
  .footerMemu {
    @media (max-width: 1200px) {
      margin-bottom: 30px;
    }
  }
}
</style>
